import { render, staticRenderFns } from "./LectureExam.vue?vue&type=template&id=69acbea2&"
import script from "./LectureExam.vue?vue&type=script&lang=js&"
export * from "./LectureExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports